import api from '../../utils/api'

export const state = {
  mvps: [],
  mvpsMeta: {},
  mvpsActive: [],
}

export const mutations = {
  SET_MVPS(state, mvps) {
    state.mvps = mvps
  },
  SET_MVPS_META(state, meta) {
    state.mvpsMeta = meta
  },
  SET_MVPS_ACTIVE(state, mvps) {
    state.mvpsActive = mvps
  },
}

export const actions = {
  async handleCreateMvp(_, body) {
    return await api.post('/mvps', body)
  },

  async handleUpdateMvp(_, { id, body }) {
    return await api.put(`/mvps/${id}`, body)
  },

  async handleDeleteMvp(_, id) {
    return await api.delete(`/mvps/${id}`)
  },

  async handleGetMvps({ commit }, payload) {
    let params = {}

    if (payload) {
      params = {
        skip: payload.skip || 0,
        limit: payload.limit || 10,
        filter: payload.filter || '',
      }
    }

    const { data: response } = await api.get('/mvps/all', { params })

    if (response && response.data && response.data.mvps) {
      commit('SET_MVPS', response.data.mvps)
      commit('SET_MVPS_META', response.meta)
    } else {
      commit('SET_MVPS', [])
      commit('SET_MVPS_META', {})
    }

    return response
  },

  async handleGetActiveMvps({ commit }) {
    const { data: response } = await api.get('/mvps/active')
    const mvps = response && response.mvps ? response.mvps : []
    commit('SET_MVPS_ACTIVE', mvps)
    return mvps
  },

  async handleGetMvpBySlug(_, slug) {
    const { data: response } = await api.get(`/mvps/slug/${slug}`)
    return response && response.mvp ? response.mvp : null
  },

  async handleGetMvp(_, id) {
    const { data: response } = await api.get(`/mvps/id/${id}`)
    return response && response.mvp ? response.mvp : null
  },

  async handleSendMvpEvents(_, { id, events }) {
    return await api.post(`/mvps/${id}/events`, { events })
  },

  async handleSendMvpFeedback(_, { id, liked, comment }) {
    const { data: response } = await api.post(`/mvps/${id}/feedback`, { liked, comment })
    return response
  },

  async handleGetMyMvpFeedback(_, id) {
    const { data: response } = await api.get(`/mvps/${id}/feedback/me`)
    return response && response.feedback ? response.feedback : null
  },

  async handleGetMvpMetrics(_, { id, filter, startDate, endDate }) {
    const { data: response } = await api.get(`/mvps/${id}/metrics`, { params: { filter, startDate, endDate } })
    return response
  },

  async handleGetMvpMetricsUsers(_, { id, skip, limit, filter, startDate, endDate }) {
    const { data: response } = await api.get(`/mvps/${id}/metrics/users`, {
      params: { skip, limit, filter, startDate, endDate }
    })
    return response
  },

  async handleGetMvpMetricsEvents(_, { id, skip, limit, filter, startDate, endDate }) {
    const { data: response } = await api.get(`/mvps/${id}/metrics/events`, {
      params: { skip, limit, filter, startDate, endDate }
    })
    return response
  },

  async handleGetMvpMetricsFeedbacks(_, { id, skip, limit, filter, startDate, endDate }) {
    const { data: response } = await api.get(`/mvps/${id}/metrics/feedbacks`, {
      params: { skip, limit, filter, startDate, endDate }
    })
    return response
  },

  async handleExportMvpMetrics(_, { id, filter, startDate, endDate }) {
    const { data: response } = await api.get(`/mvps/${id}/metrics/export`, {
      params: { filter, startDate, endDate }
    })
    return response
  },
}

export const getters = {
  getMvps: (state) => state.mvps,
  getMvpsMeta: (state) => state.mvpsMeta,
  getMvpsActive: (state) => state.mvpsActive,
}
